function ps_sf_2602_opnpop(){
  document.querySelectorAll(".pslpm_pop_field")[0].setAttribute("data-pslpmpop_dsp","true");
};
function ps_sf_2602_closepop(){
  document.querySelectorAll(".pslpm_pop_field")[0].setAttribute("data-pslpmpop_dsp","");
}

document.querySelectorAll('.sale-scroll-wrap .sale-scroll').forEach(function(el_26326_sec) {
    var isDown = false;
    let isDragging = false;
    var startX;
    var scrollLeft;

    el_26326_sec.querySelectorAll('a').forEach(a => {
      a.addEventListener('dragstart', e => e.preventDefault());
    });


    el_26326_sec.addEventListener('mousedown', function(e) {
      isDown = true;
      isDragging = false;
      el_26326_sec.style.cursor = 'grabbing';
      startX = e.pageX - el_26326_sec.offsetLeft;
      scrollLeft = el_26326_sec.scrollLeft;
    });

    el_26326_sec.addEventListener('mouseleave', function() {
      isDown = false;
      el_26326_sec.style.cursor = 'grab';
    });

    el_26326_sec.addEventListener('mouseup', function() {
      isDown = false;
      el_26326_sec.style.cursor = 'grab';
    });

    el_26326_sec.addEventListener('mousemove', function(e) {
      if (!isDown) return;
      
      var x = e.pageX - el_26326_sec.offsetLeft;
      var walk = (x - startX) * 1.5; // 1.5はスクロール速度の倍率
      if (Math.abs(walk) > 5) {
        isDragging = true;
      }
      e.preventDefault();
      el_26326_sec.scrollLeft = scrollLeft - walk;
    });

    el_26326_sec.addEventListener('click', function(e) {
      if (isDragging) {
        e.preventDefault();
        e.stopPropagation();
      }
    });

    el_26326_sec.style.cursor = 'grab';
  });